import { Component, inject } from '@angular/core';
import { FolderContinuousRecordComponent } from '../folder-continuous-record/folder-continuous-record.component';
import { FolderGlobalStore } from '../../../../../store/medicalService/folder.global-store';
import { routeParams } from '../../../../../modules/shared/shared.global-service';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';

@Component({
    selector: 'app-folder-continuous-record-dialog',
    templateUrl: './folder-continuous-record-dialog.component.html',
    styleUrl: './folder-continuous-record-dialog.component.scss',
    imports: [
        FolderContinuousRecordComponent,
    ],
    providers: [
        FolderGlobalStore,
    ],
})
export class FolderContinuousRecordDialogComponent extends BaseDialogComponent {

    private readonly folderStore = inject(FolderGlobalStore);

    constructor() {
        super();
        this.folderStore.setFolderId(routeParams.folderId());
        this.folderStore.setDialogComponent(this);
    }
}
